import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance1a0yry1hi33tg as Companion_instance,
} from '../collections/AbstractList.mjs';
import { getOrNull1d60i0672n7ns as getOrNull } from '../collections/_Arrays.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../collections/Collections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from '../collections/RandomAccess.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function enumEntries(entries) {
  return EnumEntriesList().um(entries);
}
var EnumEntriesListClass;
function EnumEntriesList() {
  if (EnumEntriesListClass === VOID) {
    class $ extends AbstractList() {
      static um(entries) {
        var $this = this.bj();
        $this.tm_1 = entries;
        return $this;
      }
      v2() {
        return this.tm_1.length;
      }
      w2(index) {
        Companion_instance.n7(index, this.tm_1.length);
        return this.tm_1[index];
      }
      vm(element) {
        if (element === null)
          return false;
        var target = getOrNull(this.tm_1, element.b2_1);
        return target === element;
      }
      y2(element) {
        if (!(element instanceof Enum()))
          return false;
        return this.vm(element instanceof Enum() ? element : THROW_CCE());
      }
      wm(element) {
        if (element === null)
          return -1;
        var ordinal = element.b2_1;
        var target = getOrNull(this.tm_1, ordinal);
        return target === element ? ordinal : -1;
      }
      w4(element) {
        if (!(element instanceof Enum()))
          return -1;
        return this.wm(element instanceof Enum() ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'EnumEntriesList', VOID, VOID, [KtList(), AbstractList(), RandomAccess()]);
    EnumEntriesListClass = $;
  }
  return EnumEntriesListClass;
}
//region block: exports
export {
  enumEntries as enumEntries20mr21zbe3az4,
};
//endregion

//# sourceMappingURL=EnumEntries.mjs.map
